import React, {Fragment, useState} from "react";
import {useContent} from "../../customHooks/useContent";
import content from "../../content/gallery";
import {PageHeader} from "../PageHeader";
import {generateRandomKey} from "../../utils/generateRandomKey";
import {Carousel} from "../Carousel";

const imagesToImport = {
    2017: ['photo5911060127258094308.jpg', 'photo5947429360564808279.jpg', 'DSCN9641.jpg', 'DSCN9705.jpg', 'DSCN9768.jpg', 'photo5947429360564808286.jpg',
        'photo5947429360564808288.jpg', 'IMG_0516.jpg', 'IMG_0639.jpg', 'IMG_0676.jpg', 'IMG_8561.jpg', 'IMG_9160.jpg', 'IMG_9178.jpg', 'IMG_9266.jpg',
        'IMG_9268.jpg', 'IMG_9292.jpg', 'photo6005923293263145432.jpg', 'photo6014886692441402445.jpg', 'photo6014886692441402446.jpg',
        'photo6014886692441402449.jpg', 'photo6014886692441402451.jpg', 'photo6014886692441402455.jpg', 'photo6017138492255087405.jpg'],
    2018: ['IMG_0205.jpg', 'IMG_0220.jpg', 'IMG_0311.jpg', 'IMG_0510.jpg', 'IMG_0626.jpg', 'IMG_0755.jpg', 'IMG_0780.jpg', 'IMG_0898.jpg', 'IMG_1038.jpg',
        'IMG_1325.jpg', 'IMG_1328.jpg', 'IMG_1329.jpg', 'IMG_1331.jpg', 'IMG_1337.jpg', 'IMG_1341.jpg', 'IMG_9803.jpg', 'IMG_9856.jpg', 'IMG_9864.jpg',
        'IMG_9895.jpg', 'IMG_9897.jpg', 'photo5954162069693640558.jpg', 'photo5954162069693640567.jpg', 'photo5954162069693640568.jpg',
        'photo5954162069693640581.jpg', 'photo5954162069693640584.jpg', 'photo5954162069693640593.jpg', 'IMG_0621_edited.jpg',
        'IMG_2526.jpg', 'IMG_2439.jpg', 'IMG_2328.jpg', 'IMG_2219.jpg', 'IMG_1814.jpg', 'IMG_1684.jpg'],
    2019: ['MIDS9625.jpg', 'UDOD6808.jpg', 'IMG_4802.jpg', 'IMG_4830.jpg', 'IMG_4943.jpg', 'IMG_5025.jpg', 'IMG_5754.jpg', 'IMG_6154.jpg', 'IMG_6804.jpg',
        'IMG_6811.jpg', 'IMG_3820.jpg', 'IMG_4280.jpg', 'IMG_4339.jpg', 'IMG_4364.jpg', 'IMG_4610.jpg', 'IMG_4717.jpg', 'IMG_5036.jpg', 'IMG_4991.jpg']
};

export const Gallery = () => {
    const text = useContent(content);

    const galleries = ['2017', '2018', '2019'];
    const [currentGallery, setCurrentGallery] = useState('2017');

    const galleryButtonName = (buttonText) => {
        const active = buttonText === currentGallery ? ' active' : '';
        return 'btn btn-default gallery-button' + active;

    };

    return (
        <Fragment>
            <PageHeader subtitle={text.subtitle} imageClass="header-school-gallery"/>
                <main className="gallery container-fluid">
                    <div className="container">
                        {galleries.map(gallery => <button className={galleryButtonName(gallery)} key={generateRandomKey()} onClick={() => setCurrentGallery(gallery)}>{gallery}</button>)}
                        {currentGallery === '2017' && <Carousel imagesToImport={imagesToImport[currentGallery]} sourceDirectory={''} />}
                        {currentGallery === '2018' && <Carousel imagesToImport={imagesToImport[currentGallery]} sourceDirectory={'2018/'} />}
                        {currentGallery === '2019' && <Carousel imagesToImport={imagesToImport[currentGallery]} sourceDirectory={'2019/'} />}
                    </div>
                </main>
        </Fragment>
    )
};
